import { withStyles } from '@mui/styles';
import React from 'react';

import logo from '../../images/logos/logo.png';
import styles from './Logo.styles';
import LogoComponent from './LogoComponent';

function Logo(props) {
  return <LogoComponent {...props} logoSrc={logo} />;
}

export default withStyles(styles)(Logo);
